module.exports = __webpack_public_path__ + "img/networkError.d5c70615.webp";